import { Btn } from "@/components/Btn";

export default function PaymentCancel() {
  return (
    <section className="flex min-h-screen items-center bg-paper text-ink">
      <div className="mx-auto max-w-[700px] px-6 py-40 text-center md:px-12" data-testid="payment-cancel">
        <p className="text-[11px] uppercase tracking-label text-ink/45">Payment cancelled</p>
        <h1 className="mt-6 font-serif text-5xl tracking-tight">No payment was taken.</h1>
        <p className="mt-6 text-lg leading-relaxed text-ink/65">Your details are safe and nothing has been charged. Whenever you're ready, you can pick up right where you left off.</p>
        <div className="mt-10 flex justify-center gap-4"><Btn to="/start" variant="primary" testid="cancel-retry">Return to checkout</Btn><Btn to="/pricing" variant="outline" dark arrow={false}>View pricing</Btn></div>
      </div>
    </section>
  );
}
